import { getAsyncTypes } from '../helpers/actionType'
import { showNotification, dispatchWithNotification } from '../redux/Notification'
import { signUpService } from '../services/signUpService'

const SCREEN_PREFIX = 'SignUp';
export const SIGNUP = getAsyncTypes(SCREEN_PREFIX, 'SIGNUP');
export const ACTIVATE = getAsyncTypes(SCREEN_PREFIX, 'ACTIVATE');
export const RESET = getAsyncTypes(SCREEN_PREFIX, "RESET");
const initState = {
  email: null,
  password: null,
  nounce: null,
  ticketLeft: null,
  ticketRight: null,
}

// reducer
export function signUpReducer(state = initState, action) {
  const payload = action.payload;
  switch (action.type) {
    case RESET.SUCCEEDED:
      return initState
    case ACTIVATE.STARTED:
      return {
        ...state,
        loading: true,
      }
    case ACTIVATE.FAILED:
      return {
        ...state,
        loading: false,
      }
    case ACTIVATE.SUCCEEDED:
      return {
        ...state,
        email: payload.email,
        usrId: payload.usrId,
        loading: false,
      }
    case SIGNUP.STARTED:
      return {
        ...state,
        loading: true,
      }
    case SIGNUP.FAILED:
      return {
        loading: false,
      }
    case SIGNUP.SUCCEEDED:
      return {
        email: payload.email,
        nounce: payload.nounce,
        password: payload.password,
        ticketRight: payload.ticketRight,
        loading: false,
      }
    default:
      return state;

  }
}

// action
export function resetSignup() {
  return { type: RESET.SUCCEEDED, payload: {} }
}

export function requestSignUp(fullName, email, password, reCaptchaRequest, refCode) {
  return (dispatch, getState, { webApi }) => {
    dispatch({ type: SIGNUP.STARTED, payload: {} })
    signUpService.signUp(email, reCaptchaRequest, refCode)
      .then(
        data => {
          dispatch({ type: SIGNUP.SUCCEEDED, payload: { ...data.data } })
        },
        error => {
          dispatchWithNotification(dispatch, { type: SIGNUP.FAILED, payload: error });
        }
      )
    // dispatch({ type: SIGNUP.SUCCEEDED, payload: { nounce: 'abc', ticketRight: '46346' }  })
  }
}

export function activateAccount(fullName, email, password, role, nounce, ticketLeft, ticketRight,refCode) {
  return (dispatch, getState, { webApi }) => {
    dispatch({ type: ACTIVATE.STARTED, payload: {} })
    return signUpService.activate(fullName, email, password, role, nounce, ticketLeft, ticketRight,refCode)
      .then(
        data => {
          dispatch({ type: ACTIVATE.SUCCEEDED, payload: data.data })
          return '';
        },
        error => {
          dispatchWithNotification(dispatch, { type: ACTIVATE.FAILED, payload: error });
          return Promise.reject(error);
        }
      )
  }
}


// WEBPACK FOOTER //
// ./src/redux/SignUp.js